<div class="dropdown-container">
  <mat-form-field class="mr-2" appearance="{{ outlined ? 'outline' : 'standard' }}">
    <mat-label>{{ 'datePresetsSelector.selectPreset' | translate }}</mat-label>
    <mat-select
      panelClass="mat-select-panel-class"
      [(ngModel)]="selectedPeriod"
      (ngModelChange)="onChangePeriod()"
      name="preset">
      <mat-option *ngFor="let item of presetsDropdownOptions" [value]="item.value">
        {{ item.label | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
